import * as React from 'react';
import { ICONS } from '../icons';
export var GenericIcon = function (_a) {
    var type = _a.type, size = _a.size, fill = _a.fill, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c;
    var Icon = ICONS[type];
    return (React.createElement("svg", { fill: fill, x: x, y: y },
        React.createElement(Icon, { size: size })));
};
//# sourceMappingURL=generic-icon.js.map